import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AttendanceStructureListSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/attendance-structures/')({
  validateSearch: zodValidator(AttendanceStructureListSearchSchema)
});